import requests from "./httpServices";

const getToken = () => localStorage.getItem("rlinks_token");

const getHeaders = () => ({
  "rlinks-token": getToken(),
});

const getDashboardData = (currentPage, rowsPerPage) => {
  return requests.get(
    `/user/dashboard-data?page=${currentPage}&limit=${rowsPerPage}`,
    {
      headers: getHeaders(),
    }
  );
};

const getRooms = (currentPage, rowsPerPage) => {
  return requests.get(`/user/rooms?page=${currentPage}&limit=${rowsPerPage}`, {
    headers: getHeaders(),
  });
};

const deleteRoom = (room) => {
  return requests.post(
    `/user/delete-room/`,
    { room },
    {
      headers: getHeaders(),
    }
  );
};

const updateRoom = (roomData) => {
  return requests.post(`/user/update-room`, roomData, {
    headers: getHeaders(),
  });
};

const updateRoomPresets = (roomId, roomName, presets) => {
  return requests.post(
    `/api/element/update-preset-by-room-id`,
    {
      roomId,
      roomName,
      presets: presets.map((p) => ({
        ...p,
        presetId: p.presetId || p._id,
        folderId: p.folderId,
        name: p.name,
      })),
    },
    {
      headers: getHeaders(),
    }
  );
};

const getFolders = () => {
  return requests.get(`/element/get-folders`, {
    headers: getHeaders(),
  });
};

const createMeeting = (meetingData) => {
  return requests.post(`/user/create-room`, meetingData, {
    headers: getHeaders(),
  });
};

const dashboardService = {
  getDashboardData,
  getRooms,
  deleteRoom,
  updateRoom,
  updateRoomPresets,
  getFolders,
  createMeeting,
};

export default dashboardService;
